import { Provider } from '@angular/core';
import { MCConfigService, MCEnvironmentsService, MCHttpWrapperService, MC_ITEM_DETAILS_VALIDATOR } from '@maslul/common-services';
import { EnvironmentsService } from '../services/shared/environments.service';
import { ConfigService } from '../services/shared/config.service';
import { ProductValidation } from '../services/fields/unique-row-details-provider';
import { MIHttpWrapperService } from '../services/shared/mi-http-wrapper.service';

export const CORE_PROVIDERS: Provider[] = [
    { provide: MCEnvironmentsService, useClass: EnvironmentsService },
    { provide: MCConfigService, useClass: ConfigService },
    {
        provide: MCHttpWrapperService,
        useClass: MIHttpWrapperService,
    },
    { provide: MC_ITEM_DETAILS_VALIDATOR, useExisting: ProductValidation },
];
